
import CancelButton from '@/components/buttons/CancelButton.vue'
import DangerButton from '@/components/buttons/DangerButton.vue'
import DangerDialog from '@/components/dialogs/DangerDialog.vue'
import { Component, Vue } from 'vue-property-decorator'
import api from '@/api'
import router from '@/router'
import { completePasswordReset } from '@/api/users'

@Component({
  components: {
    DangerButton,
    CancelButton,
    DangerDialog
  }
})
export default class LoginView extends Vue {
  isInputValid = false
  isLoading = false
  showResetPasswordDialog = false
  showPassword = false
  showConfirmedPassword = false
  email: string | null = 'admin@intrakey.de'
  password = ''
  confirmedPassword = ''

  wrongLoginTimeout: number | null = null
  emailSentTimeout: number | null = null

  targetId: string | null = null
  token: string | null = null

  // background images

  backgroundImages = [
    require('@/assets/fahrradbox_start.jpg'),
    require('@/assets/fahrradgarage_Frau.jpg'),
    require('@/assets/fahrradgarage_marbach.jpg'),
    require('@/assets/fahrradgarage_varianten.jpg'),
    require('@/assets/home_fahrradgarage_secanda_pc.jpg'),
    require('@/assets/iStock-1139819021-Frau-mit-Fahrrad-am-Wasser-2121x1414-1-1024x683-2.jpg'),
    require('@/assets/sole-bicycles-JK6lD_y3aDg-unsplash.jpg'),
    require('@/assets/BikeParkBox_Radfahrerin_App.jpg'),
    require('@/assets/dillon-wanner-FlewGATv_x0-unsplash.jpg'),
    require('@/assets/fahrradbox_bike_ride.jpg'),
    require('@/assets/Fahrradgarage-grau-mit-Fahrradmotiv-und-Smartphone-1.png')
  ]

  currentBackgroundImage = ''

  async mounted(): Promise<void> {
    this.extractTargetId()
    this.extractToken()
    this.setRandomBackground()
  }

  setRandomBackground(): void {
    const randomIndex = Math.floor(Math.random() * this.backgroundImages.length)
    this.currentBackgroundImage = this.backgroundImages[randomIndex]
  }

  extractToken(): void {
    const value = router.currentRoute.query.token

    if (Array.isArray(value) && value.length > 0) {
      this.token = value[0]
      return
    }
    this.token = value as string | null
  }

  extractTargetId(): void {
    const value = router.currentRoute.query.target

    if (Array.isArray(value) && value.length > 0) {
      this.targetId = value[0]
      return
    }
    this.targetId = value as string | null
  }

  async onResetSubmit(): Promise<void> {
    this.isLoading = true
    try {
      if (this.targetId == null || this.token == null) {
        this.$toast.error('Unbekannter Fehler')
        return
      }

      await completePasswordReset(this.targetId, this.password, this.token)

      this.$toast.success('Das Passwort wurde erfolgreich zurückgesetzt')
    } catch (e) {
      this.$toast.error(
        'Das Passwort konnte nicht zurückgesetzt werden. Bitte starte den Vorgang erneut.'
      )
    }

    this.isLoading = false

    this.$router.push('/login')
  }

  goToLogin(): void {
    router.push('login')
  }

  clearWrongLoginTimeout(): void {
    if (this.wrongLoginTimeout != null) {
      clearTimeout(this.wrongLoginTimeout)
      this.wrongLoginTimeout = null
    }
  }

  onEmailResetSubmit(): void {
    api.UsersApi.startPasswordReset(this.email!)
    this.clearEmailSentTimeout()
    this.emailSentTimeout = setTimeout(() => {
      this.emailSentTimeout = null
    }, 5000)
  }

  clearEmailSentTimeout(): void {
    if (this.emailSentTimeout != null) {
      clearTimeout(this.emailSentTimeout)
      this.emailSentTimeout = null
    }
  }
}
